import './SpecialDayOffHeader.scss'
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../providers/Profile';
import { useSpecialDayOffProvider } from '../../providers/SpecialDayOffProvider';
import Loader from '../Loader/Loader';
import { getDateInWeekDayMonthDateFormat, getEasternTime } from '../../helpers/dateHelpers';
import { months } from '../../constants/dates';

export default function SpecialDayOffHeader({ toggleSdoFormVisible }) {
    const { t } = useTranslation();
    const profileContext = useProfile();
    const profileData = profileContext?.profile?.results;
    const useSpecialDayOffContext = useSpecialDayOffProvider();
    const getTwoDigits = (param) => param < 10 ? ('0' + param) : param;

    const getLastUpdatedTime = () => {
        if(!useSpecialDayOffContext.sdoMyRequestData || !useSpecialDayOffContext.sdoInfoTabData) return;        
        const myRequestData = useSpecialDayOffContext.sdoMyRequestData;
        if(myRequestData && myRequestData[0]){
            return myRequestData[0]?.lastUpdatedOn;
        }
        else {
            return getEasternTime();
        }        
    }

    const sdoMonth = months[Number(useSpecialDayOffContext.sdoInfoTabData.sdoMonth)-1]+" "+useSpecialDayOffContext.sdoInfoTabData.sdoYear; 

    return (
        useSpecialDayOffContext.sdoMyRequestLoading ? <Loader /> : (
        <div className='sdo-header__container'>
            <div className='sdo-header__title'>
                {toggleSdoFormVisible ? <h1>{t('specialDayOff.specialDayOffHeader.title-one')} {sdoMonth}</h1> : <h1>{t('specialDayOff.specialDayOffHeader.title')} - {sdoMonth}</h1>}
                <span className='sdo-header__time'>{t('specialDayOff.specialDayOffHeader.lastUpdated')} {getDateInWeekDayMonthDateFormat(new Date (getLastUpdatedTime()))} {getTwoDigits(new Date(getLastUpdatedTime()).getHours())}:{getTwoDigits(new Date(getLastUpdatedTime()).getMinutes())} ET</span>
            </div>
            {toggleSdoFormVisible ?
                <div className='sdo-header__title'>
                    <div className='sdo-header__sub-title'>
                        <span>{profileData?.baseLocation}</span>
                        <span>{profileData?.equipment}</span>
                        <span>{profileData?.position}</span>
                    </div>
                </div> : ""
            }
        </div>
        )
    )
}
